interface EnvConfig {
  SIGNUP_SERVICE_URL: string;
  API_BASE_URL: string;
  COMPANY_SERVICE_URL: string;
  CANDIDATE_SERVICE_URL: string;
  JOB_SERVICE_URL: string;
  DAVID_CANDIDATE_URL: string;
  DAVID_RECRUITER_URL: string;
  MATCHES_SERVICE_URL: string;
  MESSAGING_SERVICE_URL: string;
  API_TIMEOUT: number;
  ENVIRONMENT: 'development' | 'production' | 'test';
  DEBUG_MODE: boolean;
}

const validateEnv = (): EnvConfig => {
  const {
    VITE_SIGNUP_SERVICE_URL,
    VITE_API_BASE_URL,
    VITE_COMPANY_SERVICE_URL,
    VITE_CANDIDATE_SERVICE_URL,
    VITE_JOB_SERVICE_URL,
    VITE_DAVID_CANDIDATE_URL,
    VITE_DAVID_RECRUITER_URL,
    VITE_MATCHES_SERVICE_URL,
    VITE_MESSAGING_SERVICE_URL,
    VITE_API_TIMEOUT,
    VITE_ENVIRONMENT,
    VITE_DEBUG_MODE
  } = import.meta.env;

  // In production (Amplify), log missing env vars but don't throw
  // This allows the app to build and run, with runtime errors only if the missing service is actually used
  const isProduction = VITE_ENVIRONMENT === 'production' || import.meta.env.PROD;

  const logMissingEnv = (varName: string) => {
    const message = `${varName} is not defined - API calls to this service will fail`;
    if (isProduction) {
      console.warn(`⚠️  ${message}`);
    } else {
      console.error(`❌ ${message}`);
    }
  };

  if (!VITE_SIGNUP_SERVICE_URL) {
    logMissingEnv('VITE_SIGNUP_SERVICE_URL');
  }

  if (!VITE_API_BASE_URL) {
    logMissingEnv('VITE_API_BASE_URL');
  }

  if (!VITE_COMPANY_SERVICE_URL) {
    logMissingEnv('VITE_COMPANY_SERVICE_URL');
  }

  if (!VITE_CANDIDATE_SERVICE_URL) {
    logMissingEnv('VITE_CANDIDATE_SERVICE_URL');
  }

  if (!VITE_JOB_SERVICE_URL) {
    logMissingEnv('VITE_JOB_SERVICE_URL');
  }

  if (!VITE_DAVID_CANDIDATE_URL) {
    logMissingEnv('VITE_DAVID_CANDIDATE_URL');
  }

  if (!VITE_MATCHES_SERVICE_URL) {
    logMissingEnv('VITE_MATCHES_SERVICE_URL');
  }

  if (!VITE_MESSAGING_SERVICE_URL) {
    logMissingEnv('VITE_MESSAGING_SERVICE_URL');
  }

  return {
    SIGNUP_SERVICE_URL: VITE_SIGNUP_SERVICE_URL || '',
    API_BASE_URL: VITE_API_BASE_URL || '',
    COMPANY_SERVICE_URL: VITE_COMPANY_SERVICE_URL || '',
    CANDIDATE_SERVICE_URL: VITE_CANDIDATE_SERVICE_URL || '',
    JOB_SERVICE_URL: VITE_JOB_SERVICE_URL || '',
    DAVID_CANDIDATE_URL: VITE_DAVID_CANDIDATE_URL || '',
    DAVID_RECRUITER_URL: VITE_DAVID_RECRUITER_URL || '',
    MATCHES_SERVICE_URL: VITE_MATCHES_SERVICE_URL || '',
    MESSAGING_SERVICE_URL: VITE_MESSAGING_SERVICE_URL || '',
    API_TIMEOUT: Number(VITE_API_TIMEOUT) || 10000,
    ENVIRONMENT: (VITE_ENVIRONMENT as EnvConfig['ENVIRONMENT']) || 'development',
    DEBUG_MODE: VITE_DEBUG_MODE === 'true'
  };
};

export const ENV = validateEnv();
export const isDev = ENV.ENVIRONMENT === 'development';
export const isProd = ENV.ENVIRONMENT === 'production';

if (isDev) {
  console.log('🔧 Environment Config:', ENV);
}
